


































































































import { Component, Mixins } from 'vue-property-decorator';

// Node module imports
import { View } from 'client-website-ts-library/plugins';

import { Map } from 'client-website-ts-library/components';

import { ListingFilter } from 'client-website-ts-library/filters';

import {
  ListingStatus,
  Office,
  MapSettings,
} from 'client-website-ts-library/types';

import {
  API,
  Config,
} from 'client-website-ts-library/services';

// Vue imports
import VideoBanner from '@/components/VideoBanner.vue';
import { ItemCyclerSlide, ItemCyclerImageSlide } from '../app_code/ItemCycler';
import ItemCycler from '../components/Cycler/ItemCycler.vue';
import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';
import Form from '../components/Forms/Form.vue';
import ProfileCards from '../components/ProfileCards.vue';
import Awards from '../components/Awards.vue';
import ContactBar from '../components/ContactBar.vue';

@Component({
  components: {
    ItemCycler,
    Listings,
    ListingSearch,
    Map,
    Form,
    ProfileCards,
    VideoBanner,
    Awards,
    ContactBar,
  },
})
export default class Home extends Mixins(View) {
  private office: Office | null = null;

  private modalActive = true;

  private mapSettings: MapSettings | null = null;

  private cyclerImages: ItemCyclerSlide[] = [
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/1',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/2',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/3',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/4',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
  ];

  private currentFilter: ListingFilter = new ListingFilter({
    Statuses: [ListingStatus.Current, ListingStatus.UnderContract],
    PageSize: 6,
  });

  private soldFilter: ListingFilter = new ListingFilter({
    Statuses: [ListingStatus.Sold],
    PageSize: 6,
  });

  mounted() {
    API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
      this.office = office;
    });
  }
}
